<template>
  <span>
    <v-btn
      v-if="showdisable"
      fab
      width="27"
      height="27"
      color="primary"
      elevation="0"
      class="btn_tippy vuetify--sacnite"
      :class="clase + (loading ? ' loading' : '')"
      :loading="loading"
      :title="isdelete ? $t('view.commons.delete') : $t('view.commons.disable')"
      @click="disable(claveComputed)">
      <em class="fas fa-trash-alt" />
    </v-btn>
  </span>
</template>
<script>
export default {
  name: "ButtonDisable"
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , clavestr: {
      default: null
      , type: String
    }
    , showdisable: {
      default: false
      , type: Boolean
    }
    , isdelete: {
      default: false
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
  }
  , computed: {
    claveComputed() {
      return this.clavestr ? this.clavestr : this.clave;
    }
  }
  , methods: {
    disable(clave) {
      this.$emit("disable", clave);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonDisable.vue